import { render, staticRenderFns } from "./MyPhotoDetail.vue?vue&type=template&id=05c894ce&scoped=true&"
import script from "./MyPhotoDetail.vue?vue&type=script&lang=ts&"
export * from "./MyPhotoDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MyPhotoDetail.vue?vue&type=style&index=0&id=05c894ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c894ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VRow,VToolbar})
